import { useCallback } from 'react';
import { useAuth } from 'auth/hooks/useAuth';
import { useNotifications } from 'shared/notifications';
import { GENERIC_MESSAGES } from 'shared/constants/GenericMessages';

export function useImpersonationGuard() {
  const { user } = useAuth();
  const { addNotification } = useNotifications();
  const isImpersonating = Boolean(user?.impersonation);

  const guardWriteAction = useCallback(
    (action?: () => void): boolean => {
      if (isImpersonating) {
        addNotification(GENERIC_MESSAGES.impersonationWriteBlocked, 'error');
        return false;
      }
      if (action) {
        action();
      }
      return true;
    },
    [isImpersonating, addNotification],
  );

  return {
    isImpersonating,
    guardWriteAction,
  };
}
